import React from 'react';
import { calculatorsData } from '../../data/knowledgeBank/calculatorsData';
import { FiExternalLink } from 'react-icons/fi';
import { FaCalculator } from 'react-icons/fa';

const categoryLabels = {
  GST: 'GST Calculators',
  Tax: 'Tax & Income Calculators',
  Loan: 'Loan & EMI Calculators',
  RERA: 'RERA Calculators',
  Other: 'Other Financial Calculators'
};

const categoryOrder = ['GST', 'Tax', 'Loan', 'RERA', 'Other'];

export default function Calculators() {
  // Group calculators by category
  const groupedCalculators = calculatorsData.reduce((acc, calc) => {
    const cat = calc.category || 'Other';
    if (!acc[cat]) acc[cat] = [];
    acc[cat].push(calc);
    return acc;
  }, {});

  return (
    <div className="page-wrapper">
      <div className="page-hero">
        <h1>Financial <span>Calculators</span></h1>
        <p>Use financial, GST, tax planning, and interest rate calculators</p>
      </div>

      <main style={{ padding: '60px 0', background: 'var(--off-white)' }}>
        <div className="container">
          {categoryOrder.map((catKey) => {
            const list = groupedCalculators[catKey] || [];
            if (list.length === 0) return null;

            return (
              <section key={catKey} style={{ marginBottom: '50px' }}>
                <h2 
                  style={{ 
                    fontSize: '1.75rem', 
                    color: 'var(--primary-dark)', 
                    marginBottom: '24px',
                    borderBottom: '2px solid var(--gray-200)',
                    paddingBottom: '10px'
                  }}
                >
                  {categoryLabels[catKey]}
                </h2>

                <div 
                  style={{ 
                    display: 'grid', 
                    gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', 
                    gap: '24px' 
                  }}
                >
                  {list.map((calc) => (
                    <div 
                      key={calc.id} 
                      style={{ 
                        background: 'var(--white)',
                        border: '1px solid var(--gray-200)',
                        borderTop: '4px solid var(--primary)',
                        borderRadius: 'var(--radius-md)',
                        padding: '28px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        gap: '20px',
                        boxShadow: 'var(--shadow-sm)',
                        transition: 'transform var(--transition)'
                      }}
                      className="calc-card"
                    >
                      <div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
                          <h3 
                            style={{ 
                              fontSize: '1.2rem', 
                              color: 'var(--text-dark)', 
                              fontFamily: 'Inter, sans-serif',
                              fontWeight: 700,
                              lineHeight: '1.4'
                            }}
                          >
                            {calc.name}
                          </h3>
                          <span 
                            style={{ 
                              fontSize: '0.75rem', 
                              background: 'rgba(13, 110, 253, 0.08)', 
                              color: 'var(--secondary)', 
                              padding: '4px 10px', 
                              borderRadius: '50px',
                              fontWeight: 600
                            }}
                          >
                            {calc.category}
                          </span>
                        </div>
                        <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem', lineHeight: '1.5' }}>
                          {calc.description}
                        </p>
                      </div>

                      <a 
                        href={calc.originalUrl} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="btn-outline"
                        style={{ 
                          display: 'flex', 
                          alignItems: 'center', 
                          justifyContent: 'center', 
                          gap: '8px', 
                          padding: '10px 16px',
                          fontSize: '0.9rem',
                          borderRadius: 'var(--radius-sm)',
                          borderColor: 'var(--secondary)',
                          color: 'var(--secondary)',
                          background: 'transparent'
                        }}
                      >
                        <FaCalculator size={15} /> Open Calculator <FiExternalLink size={13} />
                      </a>
                    </div>
                  ))}
                </div>
              </section>
            );
          })}
        </div>
      </main>
    </div>
  );
}
